import { createDetailDialog } from 'dialogs/common'
import { dialogSizes } from 'dialogs'
import Form from 'pages/producers/form'
import { api, actionCreators } from 'store/modules/producers'

const metadata = {
  icon: 'industry',
  page: 'producers',
  dialogSize: dialogSizes.XL
}

export default createDetailDialog({ metadata, api, actionCreators, Form })
